<ppl-accordion [title]="'Sick Time Summary'" [isOpen]="true">
    <div class>
        <div class>
            @if(!isReadOnly) {
            <div class="timesheet-action-buttons" style="display: flex; gap: 8px; justify-content: flex-end;">
                @if(allowCapUpdate) {
                <ppl-button label="Update Usage Cap" icon="fa fa-pencil" [customClass]="'primary-button'"
                    [iconPosition]="'left'" (click)="updateUsageCap()"></ppl-button>
                }

                <ppl-button label="View Time Off" icon="fa fa-plus" [customClass]="'primary-button'"
                    [iconPosition]="'left'" (click)="viewTimeOff()"
                    *authorize="[pageId, tabId, 'AddTimeenties', 'section', 'edit']"></ppl-button>
                <ppl-button label="Submit Time Off" icon="fa fa-plus" [customClass]="'primary-button'"
                    [iconPosition]="'left'" (click)="applySickLeave()"
                    *authorize="[pageId, tabId, 'AddTimeenties', 'section', 'edit']"></ppl-button>
            </div>
            }
        </div>
    </div>
    @if(balances.length > 0) {
    <ppl-list-table [cols]="tableColumns" [data]="balances" [disableSelection]="true" [disableSearch]="true"
        [disableSort]="true" [showCustomSearch]="false" [showColumnFilters]="false" [pagination]="false"
        [enableActions]="false" [tableScrollable]="true" tableScrollHeight="400px"
        (gridAction)="onActionClicked($event)">
    </ppl-list-table>
    }
    @else {
    <div class="alert alert-warning">No Records Found.</div>
    }
</ppl-accordion>

<div class="filter-panel">
    <ng-template #timeoffViewDialog let-cancel="cancel">
        <ppl-list-table [disableSort]="false"
            [disableSearch]="true" [showCustomSearch]="false" [enableActions]="true" [disableSelection]="true"
            [cols]="timeOffCols" [data]="timeOffData"
            [pagination]="true" [recordsPerPage]="timeOffRecordsPerPage" rowDataAccessibilityKey="timeSheetDetailId"
            [loadPage]="true" [useExternalLazyLoad]="true" [totalRecordsOverride]="timeOffTotalRecords"
            (lazyLoad)="onLazyLoad($event)"
            (gridAction)="onAction($event)" [actionButtons]="actionButtons">
        </ppl-list-table>
    </ng-template>
</div>

<div class="filter-panel">
    <ng-template #applySickLeaveDialog let-cancel="cancel">
        <ppl-add-sick-time [providerId]="providerId" [consumers]="consumers" [programName]="programName"
            (timeOffAdded)="handleAddTimeOff($event)"></ppl-add-sick-time>
    </ng-template>
</div>

<div class="filter-panel">
    <ng-template #confirmationDialog let-cancel="cancel">
        <p>Are you sure you want to remove this entry?</p>
    </ng-template>
</div>

<div class="filter-panel">
    <ng-template #updateCapDialog>
        <form nz-form [formGroup]="capForm" nzLayout="vertical">
            <nz-form-item>
                <nz-form-label class="ppl-form-label">Employer <span style="color: #ff4d4f;">*</span></nz-form-label>
                <nz-form-control [nzErrorTip]="'Please select an employer'">
                    <nz-select formControlName="employer" class="ppl-select filters" id="employer"
                        nzPlaceHolder="Employer" nzShowSearch nzAllowClear style="width: 100%;">
                        @for(emp of employers; track $index){
                        <nz-option [nzLabel]="emp?.employerName || null" [nzValue]="emp.employerPplId || null"></nz-option>
                        }
                    </nz-select>
                </nz-form-control>
            </nz-form-item>
            <nz-form-item>
                <nz-form-label>Usage Cap <span style="color: #ff4d4f;">*</span></nz-form-label>
                <nz-form-control [nzErrorTip]="'Please enter a valid usage cap'">
                    <input nz-input type="number" formControlName="usageCap" style="width: 100%;" [min]="minUsageCap" />
                </nz-form-control>
            </nz-form-item>
            <nz-form-item>
                <nz-form-label>Balance Cap <span style="color: #ff4d4f;">*</span></nz-form-label>
                <nz-form-control [nzErrorTip]="'Please enter a valid balance cap'">
                    <input nz-input type="number" formControlName="balanceCap" style="width: 100%;" [min]="minBalanceCap" />
                </nz-form-control>
            </nz-form-item>
            <nz-form-item>
                <nz-form-label>Effective Date <span style="color: #ff4d4f;">*</span></nz-form-label>
                <nz-form-control [nzErrorTip]="'Please select an effective date'">
                    <nz-date-picker formControlName="effectiveDate" nzFormat="yyyy-MM-dd" nzAllowClear="false"
                        style="width: 100%;"></nz-date-picker>
                </nz-form-control>
            </nz-form-item>
            <div style="display: flex; justify-content: flex-end; gap: 8px; margin-top: 16px;">
                <ppl-button label="Cancel" icon="fa fa-ban" [customClass]="'alt-button'" [iconPosition]="'left'"
                    (click)="cancelCapUpdate()"></ppl-button>
                <ppl-button label="Save" icon="fa fa-floppy-o" [customClass]="'primary-button'" [iconPosition]="'left'"
                    (click)="saveCapUpdate()"></ppl-button>
            </div>
        </form>
    </ng-template>
</div>